'use strict';
const gtm = require('./modules/google').tagManager;

const categoryRefinements = {
    init: function () {
        // Binds a 'click' event to the refinemets menu dropdown on COP page
        $(document).on('click', '.js-refinebar-dropdown-btn', function(e){
            e.preventDefault();
            $('.js-refinements-bar').toggleClass('open');
            $('.js-refinebar-dropdown, .js-category-refinement').slideToggle();
        });

        $(document).on('click', '.js-refinements-bar', function(e){
            const categoryPath = $(e.target).data('category');

            if (categoryPath !== undefined && categoryPath !== null) {
                gtm.pushNavigationMenuChanges(categoryPath);
            }
        });
    }
};

module.exports = categoryRefinements;
